module.exports = __webpack_public_path__ + "static/media/sterhoscope.291eab98.jpg";